<template>
    <div>
        <vx-tooltip :text="getToolTipText()">
            <vs-button id="downloadPackingSlipsButton" class="vs-con-loading__container" color="primary" @click.native="selectedDownloadPackingSlips"
                       :disabled="isButtonDisabled()">
                <font-awesome-icon :icon="['fas', 'file-pdf']" class="fa-icon" />
            </vs-button>
        </vx-tooltip>
    </div>
</template>

<script>
import apiClient from '../../services/apiClient';
import {format} from 'date-fns';

export default {
	methods: {
		getToolTipText() {
			if (this.$parent.getSelectedOrdersCount() === 0) {
				return 'Er is geen bestelling geselecteerd'
			}

			if (this.$parent.getSelectedOrdersCount() === 1) {
				return 'Download pakbon';
			}

			return 'Download pakbonnen';
		},
		isButtonDisabled() {
			return this.$parent.getSelectedOrdersCount() === 0;
		},
		selectedDownloadPackingSlips() {
			this.startLoading();

			const selectedOrders = this.$parent.getSelectedOrders();
			const orderIds = [];

			selectedOrders.forEach(order => {
				orderIds.push(order.order.id);
			});

			const params = {
				order_ids: JSON.stringify(orderIds),
			};

			apiClient.get('orders/packagingslip/download', {params, responseType: 'blob'}).then(response => {

				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement('a');
				link.href = url;

				link.setAttribute('download', 'pakbonnen-' + format(new Date(), 'Y-MM-dd_H:mm:ss') + '.pdf');
				document.body.appendChild(link);
				link.click();

				this.stopLoading();
			}).catch(error => {
				console.log(error);

				this.stopLoading();
			})
		},
		startLoading() {
			this.$vs.loading({
				container: '#downloadPackingSlipsButton',
				scale: 0.45
			})
		},
		stopLoading() {
			this.$vs.loading.close('#downloadPackingSlipsButton > .con-vs-loading')
		}
	}
}
</script>
